// extracted by css-extract-rspack-plugin
export default {"container":"oD7ot","headerOpened":"nBQpQ","suggestionEditor":"WD7WA","suggestionEditorOnlyNew":"C4QsH","suggestionHeader":"UwHD3","suggestionHeaderCollapsed":"Pev_n"};